import { PriceDisplay } from '../../components/PriceDisplay';
import {
  LeftContent,
  LeftContentLink,
  MetaLine,
  PriceAmount,
  PriceNote,
  PriceWrapper,
  Row,
  RowLink,
  RowLinkHint,
  TextContent,
  Thumbnail,
  ThumbnailImage,
  ThumbnailPlaceholder,
  Title,
} from './BookingSummaryRow.styles';
import type { BookingSummaryRowProps } from './BookingSummaryRow.types';

export function BookingSummaryRow({
  title,
  href,
  image,
  meta = [],
  price,
  priceNote,
  noImageLabel,
  newTabLabel = '(opens in a new tab)',
  link,
}: BookingSummaryRowProps) {
  const leftBody = (
    <>
      {image && (
        <Thumbnail>
          {image.src ? (
            <ThumbnailImage src={image.src} alt={image.alt ?? title} />
          ) : (
            <ThumbnailPlaceholder
              data-testid="booking-summary-thumbnail-placeholder"
              aria-label={noImageLabel}
            />
          )}
        </Thumbnail>
      )}
      <TextContent>
        <Title className="booking-summary-title">{title}</Title>
        {meta.map((line, index) => (
          <MetaLine key={`${line}-${index}`}>{line}</MetaLine>
        ))}
        {link && !href && (
          <RowLink href={link.href} target="_blank" rel="noopener noreferrer">
            {link.label}
            <RowLinkHint> {newTabLabel}</RowLinkHint>
          </RowLink>
        )}
      </TextContent>
    </>
  );

  return (
    <Row data-testid="booking-summary-row">
      {href ? (
        <LeftContentLink href={href}>{leftBody}</LeftContentLink>
      ) : (
        <LeftContent>{leftBody}</LeftContent>
      )}

      {(price || priceNote) && (
        <PriceWrapper>
          {price && (
            <PriceAmount>
              <PriceDisplay
                amount={price.amount}
                currencyCode={price.currencyCode}
                locale={price.locale}
                size="small"
              />
            </PriceAmount>
          )}
          {priceNote && <PriceNote>{priceNote}</PriceNote>}
        </PriceWrapper>
      )}
    </Row>
  );
}
